'use client';

import { Button } from '../../../Button';
import { Box, Grid } from '../../../layout';
import { Heading, Text } from '../../../typography';
import { IsVisible } from '../../IsVisible';

interface IErrorMessageProps {
  errorMessage?: string;
  reset?: () => void;
}

export function ErrorMessage({
  errorMessage = 'Any message available for this issue',
  reset,
}: IErrorMessageProps) {
  return (
    <Grid className="w-full h-[calc(100vh-200px)] items-center justify-center relative">
      <Grid className="shadow-lg items-center py-12 px-16 rounded-xl border border-zinc-200 w-fit max-w-3xl overflow-x-hidden">
        <Heading
          className="mb-4 text-center text-3xl text-gray-700"
          variant="h6"
        >
          Something went wrong!
        </Heading>
        <Text className="mb-8 text-center text-base text-gray-700">
          Please try to reload the page or contact our support to check the
          issue.
        </Text>
        <IsVisible when={process.env.NODE_ENV === 'development'}>
          <Box className="w-fit text-center mx-auto border-2 px-8 py-3 rounded-lg text-gray-700 border-yellow-500 bg-yellow-500 bg-opacity-10 relative overflow-hidden">
            <Text className="text-center font-bold text-lg text-yellow-500 uppercase break-all line-clamp-5 text-ellipsis">
              {errorMessage}
            </Text>
          </Box>
        </IsVisible>
        <Button className="mt-8 min-w-[200px] w-fit mx-auto" onClick={reset}>
          Try again
        </Button>
      </Grid>
    </Grid>
  );
}
